/** Allow optional leading minus while editing money or quantity. */
export const SIGNED_DECIMAL_INPUT_RE = /^-?\d*\.?\d*$/;

export const UNSIGNED_DECIMAL_INPUT_RE = /^\d*\.?\d*$/;

export function parseSignedDecimalBlur(raw: string): number {
    const t = raw.trim();
    if (t === '' || t === '-' || t === '+' || t === '.' || t === '-.' || t === '+.') return 0;
    const n = parseFloat(t);
    return Number.isFinite(n) ? n : 0;
}

export function parseSignedQtyCommit(raw: string): number {
    const t = raw.trim().replace(/,/g, '');
    if (t === '' || t === '-' || t === '+') return 0;
    const n = parseInt(t, 10);
    return Number.isFinite(n) ? n : 0;
}
